module.exports = __webpack_public_path__ + "img/coupon_img1.87908a02.png";